// @flow

import React from 'react';
import type { ACFFormTitle } from '../../../../types';
import { Title } from '../../../form';

export default ({ form_title }: ACFFormTitle) => (
  <Title>{form_title}</Title>
);
